const mutations = {
  setEvaluacionEnCurso (state: any, payload: any) {
    state.reviewsAnswerId = payload.reviewsAnswerId
    state.preguntas = payload.preguntas
    state.tiempoDisponible = payload.tiempoDisponible
    state.dateCreation = payload.dateCreation
    state.resultado = null
  },
  setResultado (state: any, payload: any) {
    state.resultado = payload
  },
  setCargando (state: any, payload: boolean) {
    state.cargando = payload
  },
  limpiarEvaluacion (state: any) {
    state.reviewsAnswerId = null
    state.preguntas = []
    state.tiempoDisponible = 0
    state.dateCreation = null
    state.resultado = null
    state.cargando = false
  }
}

export default mutations
